"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryParamProviderComponent = exports.QueryParamProvider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _router = require("next/router");
var _react = _interopRequireWildcard(require("react"));
var _useQueryParams = require("use-query-params");
const _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const QueryParamProviderComponent = props => {
  const {
      children
    } = props,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  const router = (0, _router.useRouter)();
  const match = /[^?|#]+/.exec(router.asPath);
  const pathname = match ? match[0] : router.asPath;
  const location = (0, _react.useMemo)(() => process.browser ? window.location : {
    search: router.asPath.replace(/[^?]+/u, '')
  }, [router.asPath]);
  const history = (0, _react.useMemo)(() => {
    const createStateHandler = type => newLocation => router[type]({
      pathname: router.pathname,
      query: router.query,
      search: newLocation?.search,
      hash: newLocation?.hash
    }, {
      pathname,
      search: newLocation?.search,
      hash: newLocation?.hash
    }, {
      shallow: true,
      scroll: false
    });
    return {
      push: createStateHandler('push'),
      replace: createStateHandler('replace'),
      location
    };
  }, [location, pathname, router]);
  return __jsx(_useQueryParams.QueryParamProvider, (0, _extends2.default)({}, rest, {
    history: history,
    location: location
  }), children);
};
exports.QueryParamProviderComponent = QueryParamProviderComponent;
const QueryParamProvider = exports.QueryParamProvider = /*#__PURE__*/(0, _react.memo)(QueryParamProviderComponent);